/**
 * Insurance provider constants shared across ShipStation applications.
 */

/** Numeric string IDs for each insurance provider. */
export const INSURANCE_PROVIDER_IDS = {
  NONE: '0',
  SHIPSURANCE: '1',
  CARRIER: '2',
  EXTERNAL: '3',
  XCOVER: '4',
  PARCELGUARD: '5',
} as const;

/** Display names for each insurance provider. */
export const INSURANCE_PROVIDER_NAMES = {
  NONE: 'None',
  SHIPSURANCE: 'Shipsurance',
  CARRIER: 'Carrier',
  EXTERNAL: 'External',
  XCOVER: 'XCover',
  PARCELGUARD: 'ParcelGuard',
} as const;
